import { render, staticRenderFns } from "./FormCliente.vue?vue&type=template&id=59db4cce"
import script from "./FormCliente.vue?vue&type=script&lang=js"
export * from "./FormCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports